var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Sub2 from '@square/dashboard-data/clients/sub2';
import { BatchCreateAndCancelSubscriptionsRequest } from '@square/dashboard-protos/models/squareup/sub2/subscription_service';
import * as Sentry from '@sentry/ember';
import { APPOINTMENTS_PREMIUM_TOKEN } from '@square/appointments-feature-upsell/services/appointments-feature-info';
import { feature } from '@square/ember-features/macros';
import { camelize } from '@square/dashboard-utilities/utils/keys';
import { SUBSCRIPTION_STATUS } from '@square/appointments-feature-upsell/services/appointments-subscription';

// Copied from frontend/@dashboard/subscriptions/addon/utils/subscriptions/tracking.js
export const SUBSCRIPTION_PLAN_DOWNGRADE = 'Subscription tier downgraded';
export const SUBSCRIPTION_PLAN_DOWNGRADE_FAILURE = 'Subscription downgrade failure';
let AppointmentsSubscriptionModal = (_dec = feature('appointments/subscription_modal_migration_milestone_0'), _dec2 = feature('employee/access_blocker_dashboard_changes'), _class = class AppointmentsSubscriptionModal extends Service {
  constructor(owner) {
    super(owner);

    // In appointments we inject the dashboard modal service as dashboardModal
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "subscriptionModalMigrationMilestone0Enabled", _descriptor4, this);
    _initializerDefineProperty(this, "employeeAccessBlockerDashboardChangesEnabled", _descriptor5, this);
    // Modal service is loaded dynamically in the constructor
    _defineProperty(this, "modal", void 0);
    if (owner.mountPoint === 'appointments') {
      this.modal = owner.lookup('service:dashboardModal');
    } else {
      this.modal = owner.lookup('service:modal');
    }
  }
  canSubscribeWithoutPaymentMethod(selectedPlan) {
    // If it's a legacy merchant and they have already used the free trial,
    // they cannot subscribe without a payment method.
    if (this.appointmentsSubscription.freeTrialHasEndedForLegacySubscription) {
      return false;
    }

    // If the selected plan is free, return true (this ignores the cancelation status)
    if (selectedPlan.isFree) {
      return true;
    }

    // If the subscription is canceled, we do not currently support reactivating it
    // through the no-payment modal.
    if (this.appointmentsSubscription.status === SUBSCRIPTION_STATUS.CANCELED) {
      return false;
    }

    // If the selected plan has a free trial remaining, return true
    return selectedPlan.freeTrialDaysLeft > 0;
  }
  getSubscribeMethod(loadedPlan, primaryBusinessLocation = '') {
    return () => {
      const currentlySubscribedLocations = this.appointmentsSubscription.subscribedLocations;
      // If there are no currently subscribed locations, use the primary business location
      let locationsToSubscribe = currentlySubscribedLocations.length === 0 ? [primaryBusinessLocation] : currentlySubscribedLocations;
      // If the merchant selected Free but used to have more subscribed locations, we only subscribe one location
      if (loadedPlan.isFree) {
        locationsToSubscribe = locationsToSubscribe.slice(0, 1);
      }
      this.appointmentsSubscription.updateAppointmentsSubscription({
        selectedPlan: loadedPlan,
        subscribedLocations: locationsToSubscribe
      });
    };
  }
  open({
    subscriptionToken,
    planToken,
    primaryBusinessLocation
  }) {
    const selectedPlan = this.appointmentsSubscription.getPlanInfo(planToken);
    if (!selectedPlan) {
      return Promise.resolve();
    }
    if (this.subscriptionModalMigrationMilestone0Enabled) {
      return this.confirmButtonCallbackComplete({
        selectedPlan
      });
    } else {
      if (this.canSubscribeWithoutPaymentMethod(selectedPlan)) {
        const planInPlanGroup = this.appointmentsSubscription.getPlanInfo(selectedPlan.token);
        if (!planInPlanGroup) {
          return Promise.resolve();
        }

        // eslint-disable-next-line dashboard/require-modal-open-component
        return this.modal.open('subscriptions/merchant/verticals/appointments-no-payment-activation-modal', {
          planToken: selectedPlan.token,
          subscription: this.appointmentsSubscription.subscription,
          planName: selectedPlan.name,
          renewalCycle: planInPlanGroup.renewalCycle,
          pricing: {
            label: this.formatter.currency(selectedPlan.priceInCent, selectedPlan.currencyCode)
          },
          isFree: selectedPlan.isFree,
          numFreeTrialDays: selectedPlan.freeTrialDaysLeft,
          zIndexClass: 'appointments-feature-upsell__subscription-modal',
          subscribeMethod: this.getSubscribeMethod(selectedPlan, primaryBusinessLocation)
        });
      }
      // eslint-disable-next-line dashboard/require-modal-open-component
      return this.modal.open('subscriptions/sub2-activation-modal', {
        planToken: selectedPlan.token,
        subscriptionToken,
        shouldShowBackButton: true,
        zIndexClass: 'appointments-feature-upsell__subscription-modal'
      });
    }
  }
  hasEmployeeManagement(planToken) {
    return planToken === APPOINTMENTS_PREMIUM_TOKEN;
  }
  async handleDowngrade({
    selectedPlanComponents,
    selectedPlan,
    reason,
    planBillingCycle,
    subscribedLocations
  }) {
    let success = false;
    try {
      // If no plan has been selected, we cannot continue.
      if (!selectedPlan) {
        throw new Error('No plan selected');
      }
      // Create a subscription creation request for each plan component (these will be additional non-appointments plans selected while downgrading)
      const createRequests = selectedPlanComponents.map(planComponent => {
        return BatchCreateAndCancelSubscriptionsRequest.CreateSubscription.create({
          planToken: planComponent.plan.productToken,
          startInFreeTrialNoObligationState: false,
          planBillingCycle
        });
      });

      // Create subscription creation requests through Sub2
      const {
        created
      } = await Sub2.externalBatchCreateAndCancelSubscriptions({
        createRequests,
        updateRequests: [],
        cancelRequests: [],
        reason
      });
      let updateResults;
      if (subscribedLocations) {
        // If subscribed locations are specified, update through appointments-subscription service
        updateResults = await this.appointmentsSubscription.updateAppointmentsSubscription({
          selectedPlan,
          subscribedLocations
        });
      } else {
        // Otherwise, open the activation modal
        updateResults = await this.openSub2ActivationModal({
          selectedPlan
        });
      }
      if (updateResults.didSubscribe && created.every(creation => creation.succeeded)) {
        success = true;
        this.dataApi.track(SUBSCRIPTION_PLAN_DOWNGRADE);
      } else {
        this.dataApi.track(SUBSCRIPTION_PLAN_DOWNGRADE_FAILURE);
      }
    } catch (err) {
      Sentry.withScope(scope => {
        scope.setExtra('err', err);
        Sentry.captureException(new Error('AppointmentsSubscriptionModalService: Error while downgrading subscription.'));
      });
    }
    return success;
  }
  get hasMultipleSubscribedLocations() {
    return this.appointmentsSubscription.subscribedLocations && this.appointmentsSubscription.subscribedLocations.length > 1;
  }
  get currentAppointmentsPlanToken() {
    // If there is no subscription for the tiered modal, it means that this is a migration workflow.
    // If the merchant subscriptions has the 'appointments' subscription, then we should return 'appointments'.
    if (!this.appointmentsSubscription.subscription) {
      if (this.appointmentsSubscription.isOldPlan) {
        return 'appointments';
      }
    } else {
      return this.appointmentsSubscription.planToken;
    }
    return '';
  }
  async fetchNewSubscription() {
    await this.appointmentsSubscription.fetch({
      merchantToken: this.appointmentsSubscription.merchantToken ?? '',
      merchantCountryCode: this.appointmentsSubscription.countryCode ?? '',
      hasAppointmentsAccount: true // If we are showing this modal, the merchant has access to appointments
    });
  }
  // ---------------------------------------------------------------------------------- //
  // -------------------------- Submit Button Actions Begins -------------------------- //
  openSub2ActivationModal({
    selectedPlan
  }) {
    if (this.canSubscribeWithoutPaymentMethod(selectedPlan)) {
      // eslint-disable-next-line dashboard/require-modal-open-component
      return this.modal.open('subscriptions/merchant/verticals/appointments-no-payment-activation-modal', {
        planToken: selectedPlan.token,
        subscription: this.appointmentsSubscription.subscription,
        planName: selectedPlan.name,
        renewalCycle: selectedPlan.renewalCycle,
        pricing: {
          label: this.formatter.currency(selectedPlan.priceInCent, selectedPlan.currencyCode)
        },
        isFree: selectedPlan.isFree,
        numFreeTrialDays: selectedPlan.freeTrialDaysLeft,
        shouldShowBackButton: true,
        afterSaveAction: async () => {
          await this.fetchNewSubscription();
        },
        zIndexClass: 'appointments-feature-upsell__subscription-modal'
      });
    } else {
      // eslint-disable-next-line dashboard/require-modal-open-component
      return this.modal.open('subscriptions/sub2-activation-modal', {
        planToken: selectedPlan.token,
        subscriptionToken: this.appointmentsSubscription.subscription?.token,
        shouldShowBackButton: true,
        zIndexClass: 'appointments-feature-upsell__subscription-modal'
      });
    }
  }
  openDowngradeModal({
    selectedPlan,
    subscribedLocations
  }) {
    // As the downgrade modals expect a subscription using camelCase keys,
    // We need to manually camelize the subscription object to avoid some fields (plan_name) being undefined
    // eslint-disable-next-line dashboard/require-modal-open-component
    return this.modal.open('subscriptions/merchant/verticals/appointments-downgrade-features-modal', {
      planGroup: this.appointmentsSubscription.planGroup,
      subscription: camelize(this.appointmentsSubscription.subscription),
      selectedPlan,
      subscribedLocations,
      currentPlanToken: this.currentAppointmentsPlanToken,
      currentSubscriptionName: this.appointmentsSubscription.planName,
      downgradeCallback: this.handleDowngrade,
      zIndexClass: 'appointments-feature-upsell__subscription-modal'
    });
  }
  async openLocationManagementAndDowngradeModal({
    selectedPlan
  }) {
    // eslint-disable-next-line dashboard/require-modal-open-component
    return this.modal.open('subscriptions/merchant/manage-subscription/manage-location-modal', {
      selectedPlan,
      freePlan: selectedPlan.isFree,
      activeSubunits: await this.appointmentsSubscription.getActiveSubunits(),
      isLegacyPlan: this.appointmentsSubscription.isOldPlan,
      submitLocationsCallback: details => {
        return this.openDowngradeModal({
          selectedPlan,
          subscribedLocations: details.subscribedLocations
        });
      },
      zIndexClass: 'appointments-feature-upsell__subscription-modal'
    });
  }

  /**
   * This logic is taken from the appointments-tiered-manage-subscription-modal component. It is partially modified, and
   * all flows that relate to legacy merchants redirect the seller to the pricing & subs page.
   *
   *  Is the seller on the new subscription? (this.appointmentsSubscription.subscription exists)
   *  - Yes
   *      Is the selected plan free?
   *      - Yes
   *          Does the merchant have multiple appointment locations?
   *          - Yes => Should select one location only and then downgrade, and call 'UpdateSubscription' endpoint.
   *          - No
   *             Is it a downgrade (i.e. previous plan was not free)? ** THIS IS DIFFERENT FROM THE TIERED MODAL **
   *            - Yes => Should open downgrade modal and call 'Sub2' endpoint.
   *            - No => Should open sub2-activation modal and call 'Sub2' endpoint.
   *      - No
   *          Is it a downgrade?
   *          - Yes => Should open downgrade modal and call the Sub2 endpoint.
   *          - No
   *              Can the merchant use the subscription for free (ie it's free or has trial)?
   *              - Yes => Should open appointments-no-payment-activation-modal and call Sub2 endpoint.
   *              - No  => Should open sub2-activation modal and call Sub2 endpoint.
   *  - No (This only happens when the existing sellers wants to migrate to the new subscription).
   *      - Redirect to pricing & subscriptions page
   */
  async confirmButtonCallbackComplete({
    selectedPlan
  }) {
    const beforeConfirmHasEmployeeManagement = this.hasEmployeeManagement(this.appointmentsSubscription.planToken);
    const afterConfirmHasEmployeeManagement = this.hasEmployeeManagement(selectedPlan.token);
    let modalResponse = null;
    if (this.appointmentsSubscription.subscription) {
      if (selectedPlan.isFree) {
        if (this.hasMultipleSubscribedLocations) {
          modalResponse = await this.openLocationManagementAndDowngradeModal({
            selectedPlan
          });
        } else {
          if (this.appointmentsSubscription.isPlanDowngrade(selectedPlan)) {
            modalResponse = await this.openDowngradeModal({
              selectedPlan
            });
          } else {
            modalResponse = await this.openSub2ActivationModal({
              selectedPlan
            });
          }
        }
      } else {
        if (this.appointmentsSubscription.isPlanDowngrade(selectedPlan)) {
          modalResponse = await this.openDowngradeModal({
            selectedPlan
          });
        } else {
          modalResponse = await this.openSub2ActivationModal({
            selectedPlan
          });
        }
      }
    } else {
      this.appointmentsSubscription.redirectToSubscriptionPage({
        unitToken: this.appointmentsSubscription.merchantToken ?? '',
        source: 'appts-manage',
        selectedPlanToken: selectedPlan.token,
        planGroupToken: 'appointments-group'
      });
    }

    // If modal response is undefined, we must set didSubscribe to false
    if (!modalResponse) {
      modalResponse = {
        didSubscribe: false
      };
    }

    // If the merchant had Team Plus, but doesn't have it anymore (i.e. downgrading from Premium), we should show the
    // appointments-lose-team-plus-modal.
    if (!afterConfirmHasEmployeeManagement && beforeConfirmHasEmployeeManagement && modalResponse.didSubscribe && !this.employeeAccessBlockerDashboardChangesEnabled) {
      // eslint-disable-next-line dashboard/require-modal-open-component
      await this.modal.open('subscriptions/merchant/verticals/appointments-lose-team-plus-modal', {
        zIndexClass: 'appointments-feature-upsell__subscription-modal'
      });
    }
    return modalResponse;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "subscriptionModalMigrationMilestone0Enabled", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "employeeAccessBlockerDashboardChangesEnabled", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "handleDowngrade", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDowngrade"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSub2ActivationModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openSub2ActivationModal"), _class.prototype), _class);
export { AppointmentsSubscriptionModal as default };